define('WidgetInstanceView',['jquery','underscore','backbone','app','hooks','SubView','template!blocks/default-widget-instance'],
    function ($,_,backbone,app,hooks,SubView,defaultTemplate) {

    var WidgetModelView = backbone.View.extend(SubView).extend({
        className:'widget-instance',
        name:'WidgetInstanceView',
        events:{
        },
        initialize:function(model){
            //
            var view = this;
            view.subviews = [];
            view.model = model;
            view.setup();
            view.preRender();
        },
        setup:function(){
            //
        },
        _setAttributes:function(attributes){
            var view = this,
                purge_attr = _.pick(attributes,'class');
            if(attributes.id) {
                purge_attr['data-id'] = attributes.id;
            }
            if(attributes.params){
                purge_attr['data-template']= attributes.params.template || 'default';
            }
            purge_attr['data-widget']= attributes.widget_class_name || 'default';
            view.$el.attr(purge_attr);
        },
        getTemplateOptions:function(){
            return this.model;
        },
        getTemplate:function(){
            return defaultTemplate;
        },
        preRender: function(){
            var view = this,
                tpl;
            try {
                tpl = view.getTemplate()(view.getTemplateOptions());
                view.$el.html(tpl);
                view.$el = $(view.el);
            }catch(err){
                app.error('WidgetInstanceView'+err.toString(),view.model.toJSON());
                app.blockError(view.$el);
            }
        },
        render:function(){
            var view = this;
            view.afterRender();
            view.delegateEvents();
            return view;
        },
        rerender:function(){
            var view = this;
            view.preRender();
            view.render();
        },
        afterRender:function() {
            //
        }
    });

    // méthode statique pour factoriser les WidgetView
    WidgetModelView.factoryWidgetView = function(widgetInstance){

        var viewClassName = WidgetModelView; // default view

        hooks.execHook('factoryWidgetInstanceView',widgetInstance,function(widgetModelView){
            viewClassName = widgetModelView;
        });

        return viewClassName;
    };

    return WidgetModelView;

});
